module.exports = __webpack_public_path__ + "img/a2.782eadd8.jpg";